export enum UserActionTypes {
  CREATE_USER = 'CREATE_USER',
  GET_USER = 'GET_USER',
  AUTHENTICATE_USER = 'AUTHENTICATE_USER',
  STORE_USER_DATA = 'STORE_USER_DATA',
  CLEAR_USER_DATA = 'CLEAR_USER_DATA',
}
